import { PublicKey } from "@solana/web3.js";
import { makeDSTProgram } from "./makeDSTProgram.js";

export function setBaseFee({
  baseFee,
  dst,
  operator,
}: {
  dst: PublicKey;
  operator: PublicKey;
  baseFee: number;
}) {
  const program = makeDSTProgram();
  const result = program.methods.setBaseFee(baseFee).accountsPartial({
    operator,
    dst,
  });

  return result;
}
